var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { createPath, useLocation, useNavigate, } from 'react-router-dom';
import { NotFoundError } from '@lucidlink/sdk/fetcher';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { useDependency, useGetAuthCodeHandler, useImperativeGetUserLoginConfig, useSSOClient, useSubscribeToBroadcastMessage, WORKSPACE_NAME_STEP_WORKSPACE_NOT_FOUND_ERROR, } from '@lucidlink/workspacemanagement';
export const useLoginWorkspaceName = ({ handleGeneralLoginError, loginEmail, setAccessToken, setNextStep, }) => {
    _react_refresh_temp_1();
    const { errors, formData, methods: { injectErrors }, } = useFormRoot();
    const clientBaseUrl = useDependency('CLIENT_BASE_URL');
    const { exchangeCode, initializeAuthentication } = useSSOClient();
    const navigate = useNavigate();
    const location = useLocation();
    const onAuthCodeReceived = useGetAuthCodeHandler({
        exchangeCode,
        handleGeneralLoginError,
        loginEmail,
        setAccessToken,
        setNextStep,
    });
    useSubscribeToBroadcastMessage({
        callback: onAuthCodeReceived,
        messageType: 'auth-code-received',
    });
    const { mutateAsync: getUserLoginConfigPromise } = useImperativeGetUserLoginConfig();
    // No validator in the form for now, so just check for length and errors
    const isSubmitDisabled = errors?.workspaceName?.length > 0 || !formData.workspaceName;
    const { isPending: isPendingSubmit, mutate: submit } = useMutation({
        mutationFn: async () => {
            if (isSubmitDisabled) {
                return;
            }
            const { workspaceName } = formData;
            if (!workspaceName) {
                return;
            }
            // Call with workspaceName to get workspace-specific SSO config
            const config = await getUserLoginConfigPromise({
                userEmail: loginEmail,
                workspaceName,
            });
            if (!config?.ssoLoginParams) {
                // WARN: If not 404 Not Found, but we still do not have ssoLoginParams
                // something is definitely wrong
                handleGeneralLoginError();
                return;
            }
            if (config.workspaceId) {
                void navigate(createPath(location), {
                    replace: true,
                    state: {
                        ...location.state,
                        navigatedFrom: `/workspaces/${config.workspaceId}`,
                    },
                });
            }
            // Initiate SSO with workspace-specific config
            await initializeAuthentication({
                clientId: config.ssoLoginParams.clientId,
                serverUri: config.ssoLoginParams.openIdConnectUrl,
                redirectUri: `${clientBaseUrl}/sso-landing`,
                loginHint: loginEmail,
            });
        },
        onError: (error) => {
            if (error instanceof NotFoundError) {
                injectErrors({
                    workspaceName: {
                        errors: [WORKSPACE_NAME_STEP_WORKSPACE_NOT_FOUND_ERROR],
                    },
                });
                return;
            }
            // Only error we handle in the UI for now is 404 Not Found,
            // anything else resets the form
            handleGeneralLoginError();
        },
    });
    return {
        formErrors: errors,
        isLoading: isPendingSubmit,
        isSubmitDisabled,
        onContinue: submit,
    };
};
_react_refresh_temp_1(useLoginWorkspaceName, "GQM6v3tin249/2CnxadYD9iyl/A=", false, () => [useFormRoot, useDependency, useSSOClient, useNavigate, useLocation, useGetAuthCodeHandler, useSubscribeToBroadcastMessage, useImperativeGetUserLoginConfig, useMutation]);
